/*
session-storage-api.js

-GE CONFIDENTIAL-
Type: Source Code

Copyright (c) 2021, GE Healthcare Co.
All Rights Reserved

This unpublished material is proprietary to GE Healthcare. The methods and
techniques described herein are considered trade secrets and/or
confidential. Reproduction or distribution, in whole or in part, is
forbidden except by express written permission of GE Healthcare.
*/
define('sessionStorage',['angular'], function () {

    // Module Dependencies
    var dependencies = [];

    // Module Definition
    var mod = angular.module('Services.SessionStorage', dependencies);

    /**
     * @name loginApi
     * @type factory
     *
     * @description
     * A factory that provides methods for making requests to the login REST API.
     */
    mod.factory('sessionStorage', [function () {

        function setStorageData(param, data) {
            sessionStorage.setItem(param, JSON.stringify(data));
        }

        function getStorageData(param) {
            return JSON.parse(sessionStorage.getItem(param));
        }

        function removeItem(param) {
            sessionStorage.removeItem(param);
        }

        function removeAllStorageData() {
            sessionStorage.clear();
        }

        return {
            // getters and setters
            getStorageData: getStorageData,
            setStorageData: setStorageData,
            removeItem: removeItem,
            removeAllStorageData: removeAllStorageData
        };


    }]);

});

